import {
  Box,
  IconButton,
  Drawer as MUIDrawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PropsWithChildren, useEffect, useState } from "react";
import AppLogo from "../../assets/Logo.svg";
import { purpleLight } from "../../theme/colors";
import BaseLayout from "../base/base_layout";
import Drawer from "./components/drawer";
import MerchantDrawer from "../merchant/components/merchant_drawer";
import Navbar from "./components/navbar";

const MOBILE_DRAWER_WIDTH = 260;

export default function MainLayout({
  children,
  dense = false,
}: PropsWithChildren<{
  dense?: boolean;
}>) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = dense ? 96 : 108;

  // Sidebar is a hamburger-triggered overlay on mobile, always-open on
  // tablet/desktop — resync when crossing the breakpoint (e.g. rotating a
  // device) so it doesn't get stuck open/closed.
  const [drawerOpen, setDrawerOpen] = useState(!isSmallScreen);
  useEffect(() => {
    setDrawerOpen(!isSmallScreen);
  }, [isSmallScreen]);

  // Check if user is a merchant
  const isMerchant = () => {
    const merchantData = sessionStorage.getItem('merchant_data');
    return merchantData !== null;
  };
  return (
    <BaseLayout>
      <Box
        display="flex"
        flexDirection="row"
        height="100vh"
        width="100vw"
        sx={{}}
      >
        <Box width={isSmallScreen ? 0 : drawerWidth} flexShrink={0}>
          <MUIDrawer
            variant={isSmallScreen ? "temporary" : "permanent"}
            open={isSmallScreen ? drawerOpen : true}
            onClose={() => setDrawerOpen(false)}
            ModalProps={{ keepMounted: true }}
            PaperProps={{
              sx: {
                width: isSmallScreen ? MOBILE_DRAWER_WIDTH : drawerWidth,
                position: "relative",
                bgcolor: purpleLight,
                border: "none",
                boxShadow: "2px 0 16px rgba(145, 39, 143, 0.08)",
              },
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "column", height: "100vh" }}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={1.5}
                sx={{ borderBottom: "1px solid rgba(145, 39, 143, 0.12)" }}
              >
                <IconButton sx={{ height: 64, width: 64 }}>
                  <img src={AppLogo} width={40} height={40} alt="AMI" />
                </IconButton>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "stretch",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                {isMerchant() ? (
                  <MerchantDrawer
                    horizontal={isSmallScreen}
                    onItemClick={() => setDrawerOpen(false)}
                  />
                ) : (
                  <Drawer
                    horizontal={isSmallScreen}
                    onItemClick={() => setDrawerOpen(false)}
                  />
                )}
              </Box>
            </Box>
          </MUIDrawer>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minHeight: 68,
              bgcolor: "#FFFFFF",
              borderBottom: "1px solid #EFE3EF",
              px: dense ? 4 : 3,
            }}
          >
            <Navbar onMenuClick={isSmallScreen ? () => setDrawerOpen(true) : undefined} />
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                paddingRight: 2,
                paddingBottom: dense ? 0 : 6,
                width: "100%",
              }}
              ml={2}
              mt={2}
            >
              {children}
            </Box>
            {/* <Box sx={{ width: 128 }}></Box> */}
          </Box>
        </Box>
      </Box>
    </BaseLayout>
  );
}
